import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const Anchor = styled('a', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
});

const Before = styled('div', {
  static: {
    display: 'flex',
    alignItems: 'center',
  },
  dynamic: ({ height, padding }) => {
    return {
      height: height,
      paddingRight: padding,
    };
  },
});

const After = styled('div', {
  static: {
    display: 'flex',
    alignItems: 'center',
  },
  dynamic: ({ height, padding }) => {
    return {
      height: height,
      paddingLeft: padding,
    };
  },
});

export const ExitLinkEnhancer = ({
  className,
  beforeClassName,
  afterClassName,
  styles,
  children,
  before,
  after,
  height,
  padding,
  to,
  handleClick,
  'data-testid': dataTestid,
  ...props
}) => {
  if (!before && !after) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className={className}
        {...(dataTestid && { 'data-testid': dataTestid })}
      >
        {children}
      </a>
    );
  }

  return (
    <Anchor
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={handleClick}
      {...(dataTestid && { 'data-testid': dataTestid })}
    >
      {before && (
        <Before
          className={beforeClassName}
          cssProps={{
            height: height,
            padding: padding,
          }}
        >
          {typeof before === 'function' ? before(props) : before}
        </Before>
      )}
      {children}
      {after && (
        <After
          className={afterClassName}
          cssProps={{
            height: height,
            padding: padding,
          }}
        >
          {typeof after === 'function' ? after(props) : after}
        </After>
      )}
    </Anchor>
  );
};

ExitLinkEnhancer.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  beforeClassName: PropTypes.string,
  afterClassName: PropTypes.string,
  styles: PropTypes.shape({}),
  children: PropTypes.node,
  before: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  after: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  height: PropTypes.string,
  'data-testid': PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleClick: PropTypes.func.isRequired,
};

ExitLinkEnhancer.defaultProps = {
  className: null,
  beforeClassName: null,
  afterClassName: null,
  styles: null,
  children: null,
  before: null,
  after: null,
  height: null,
  'data-testid': null,
  padding: '5px',
};
